/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisDefinitionsAPI
 * @hideconstructor
 * @classdesc Represents the API to access the visualization definitions that are registered in the dashboard application.
 */

define([], () => {
	class VisDefinitionsAPI {
		/**
		 * @function VisDefinitionsAPI#getList
		 * @description Return a list of visualization definitions.
		 * @public
		 *
		 * @return {VisDefinitionAPI[]}
		 *
		 */
		getList() {}


		/**
		 * @function VisDefinitionsAPI#getById
		 * @description Return a list of visualization definitions.
		 * @public
		 *
		 * @param {String} id
		 * @return {VisDefinitionAPI}
		 *
		 */
		getById(/* id */) {}


		/**
		 * @function VisDefinitionsAPI#getByType
		 * @description Return a list of visualization definitions.
		 * @public
		 *
		 * @param {String} type
		 * @return {VisDefinitionAPI}
		 *
		 */
		getByType(/* type */) {}

		/**
		 * @function VisDefinitionsAPI#refresh
		 * @description Refresh definitions
		 * @public
		 *
		 * @return {Promise<undefined>}
		 */
		refresh() {}

		/**
		 * @function VisDefinitionsAPI#loadById
		 * @description Loads a specific definition by ID
		 * @public
		 *
		 * @return {Promise<undefined>}
		 */
		loadById(/* id */) {}

		/**
		 * @function VisDefinitionsAPI#on
		 * @description Register an event handler for the visualization definitions
		 * @param {String} eventName Name of the feature event
		 * @param {function} handler Event handler to be called when the event occurrs.
		 * @param {object} context Context of the event
		 * Multiple handlers can be registered with the same <strong>eventName</strong>.
		 * Each handlers needs to be registered and unregistered individually.
		 */
		on() {}

		/**
		 * @function VisDefinitionsAPI#off
		 * @description Unregister an event handler that was registered with {@link VisDefinitionsAPI#on}
		 * @param {String} eventName Name of the feature event
		 * @param {function} handler Event handler to be called when the event occurrs
		 * @param {object} context Context of the event
		 */
		off() {}

		/**
		 * @function VisDefinitionsAPI#registerModifier
		 * @description Register a modifier object that can be used to extend the vis definitions
		 * @param {VisDefinitionModifier} modifier
		 */
		registerModifier() {}


		/**
		 * @function VisDefinitionsAPI#deregisterModifier
		 * @description Deregister a previously registered definition modifier
		 * @param {VisDefinitionModifier} modifier
		 */
		deregisterModifier() {}
	}
	return VisDefinitionsAPI;
});
